import { useEffect, useState } from "react";
import logo from "../assets/logo-findeo.jpeg";

const nav = [
  { href: "#accueil", label: "Accueil" },
  { href: "#apropos", label: "À propos" },
  { href: "#solutions", label: "Solutions" },
  { href: "#ecosysteme", label: "Écosystème" },
  { href: "#vision", label: "Vision" },
  { href: "#partenaires", label: "Partenaires" },
  { href: "#investisseurs", label: "Investisseurs" },
  { href: "#contact", label: "Contact" },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background/85 backdrop-blur-lg border-b border-border shadow-soft"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between">
        <a href="#accueil" className="flex items-center gap-3" data-testid="logo-link">
          <img src={logo} alt="Logo Groupe Findeo" className="h-10 w-10 rounded-full object-cover ring-2 ring-royal/40" />
          <span className={`font-display font-bold tracking-tight text-lg ${scrolled ? "text-foreground" : "text-white"}`}>
            GROUPE <span className="text-gradient-brand">FINDEO</span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {nav.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors hover:text-royal ${
                scrolled ? "text-foreground/80" : "text-white/85"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="header-cta"
          className="hidden lg:inline-flex items-center rounded-full bg-gradient-brand px-5 py-2 text-sm font-semibold text-white shadow-soft hover:scale-[1.03] transition"
        >
          Devenir partenaire
        </a>
        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
          className={`lg:hidden p-2 rounded-md ${scrolled ? "text-foreground" : "text-white"}`}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {open ? <path d="M6 6l12 12M6 18L18 6" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-background border-t border-border" data-testid="mobile-menu">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-3">
            {nav.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-foreground/80 font-medium py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center items-center rounded-full bg-gradient-brand px-5 py-3 text-sm font-semibold text-white"
            >
              Devenir partenaire
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
